import { useTranslation } from "react-i18next"
import ModalTarot from "../../tarot/presentation/modal-tarot"
import ReactGA from 'react-ga4'

export default function HomeHeader() {
	const {t, i18n } = useTranslation()

	const changeLanguage = (lng: string) => {
		ReactGA.event({
			category: 'Language',
			action: 'Change',
			label: lng
		})
		i18n.changeLanguage(lng)
	}
  return (
    <>
			<ModalTarot/>
      <div className="ast_top_header">
				<div className="container">
					<div className="row">
						<div className="col-lg-12 col-md-12 col-sm-12 col-12">
							{/* <div className="ast_contact_details">
								<ul>
									<li><i className="fa fa-phone" aria-hidden="true"></i> +1800 326 3264</li>
									<li><a href="#"><i className="fa fa-envelope-o" aria-hidden="true"></i> support@website.com</a></li>
								</ul>
							</div> */}
							<div className="ast_autho_wrapper">
								<ul>
									{/* <li><a className="popup-with-zoom-anim" href="#login-dialog"><i className="fa fa-sign-in" aria-hidden="true"></i> Log In</a></li> */}
									{/* <li><a className="popup-with-zoom-anim" href="#signup-dialog"><i className="fa fa-user-plus" aria-hidden="true"></i> Sign Up</a></li> */}
									<li className="ast_search">
										<div>{t('language')} <i className="fa fa-language"></i></div>
										<div className="ast_search_field">
											<ul style={{display: 'flex', flexDirection: 'column', cursor: 'pointer'}}>
												<li onClick={() => changeLanguage('es')} >Español</li>
												<li onClick={() => changeLanguage('en')} >English</li>
											</ul>
											{/* <form>
												<input type="text" placeholder="Search Here" />
												<button type="button"><i className="fa fa-search"></i></button>
											</form> */}
										</div>
									</li>
									{/* <li className="ast_cart">
										<a href="javascript:;"><i className="fa fa-shopping-cart"></i></a>
										<div className="ast_cart_box">
											<div className="ast_cart_list">
												<ul>
													<li>
														<div className="ast_cart_img">
															<img src="images/content/Products/thumb1.jpg" className="img-responsive" />
														</div>
														<div className="ast_cart_info">
															<a href="#">Yellow Sapphire</a>
															<p>1 X $20.00</p>
															<a href="javascript:;" className="ast_cart_remove"><i className="fa fa-trash"></i></a>
														</div>
													</li>
													<li>
														<div className="ast_cart_img">
															<img src="images/content/Products/thumb1.jpg" className="img-responsive" />
														</div>
														<div className="ast_cart_info">
															<a href="#">yantra</a>
															<p>1 X $10.00</p>
															<a href="javascript:;" className="ast_cart_remove"><i className="fa fa-trash"></i></a>
														</div>
													</li>
												</ul>
											</div>
											<div className="ast_cart_total">
												<p>total<span>$30.00</span></p>
											</div>
											<div className="ast_cart_btn">
												<button type="button">view cart</button>
												<button type="button">checkout</button>
											</div>
										</div>
									</li> */}
								</ul>
								{/* <div id="login-dialog" className="zoom-anim-dialog mfp-hide">
									<h1>Login Form</h1>
									<form>
										<input type="text" placeholder="Email" />
										<input type="password" placeholder="Password"/>
										<div className="ast_login_data">
											<label className="tp_custom_check" htmlFor="remember_me">Remember me <input type="checkbox" name="ast_remember_me" value="yes" id="ast_remember_me" /><span className="checkmark"></span>
											</label>
											<a href="#">Forgot password ?</a>
										</div>
										<button type="submit" className="ast_btn">Login</button>
										<p>Create An Account ? <a href="#">SignUp</a></p>
									</form>
								</div>
								<div id="signup-dialog" className="zoom-anim-dialog mfp-hide">
									<h1>signup form</h1>
									<form>
										<input type="text" placeholder="Name" />
										<input type="text" placeholder="Email" />
										<input type="password" placeholder="Password" />
										<input type="text" placeholder="Mobile Number" />
										<select>
											<option value="male">Male</option>
											<option value="female">Female</option>
										</select>
										<button type="submit" className="ast_btn">submit</button>
										<p>Have An Account ? <a href="#">Login</a></p>
									</form>
								</div> */}
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* <div className="ast_header_bottom">
				<div className="container">
					<div className="row">
						<div className="col-lg-3 col-md-3 col-sm-3 col-10">
							<div className="ast_logo">
								<a href="index.html"><img src="https://dummyimage.com/160x64" alt="Logo" title="Logo" /></a>
							</div>
						</div>
						<div className="col-lg-9 col-md-9 col-sm-9 col-2">
							<div className="ast_main_menu_wrapper">
								<div className="ast_menu">
									<ul>
										<li className="as_submenu_li"><a href="#">home</a>
											<ul className="submenu">
												<li><a href="index.html">home</a></li>
												<li><a href="index-horoscope.html">horoscope</a></li>
												<li><a href="index-tarot.html">tarot card</a></li>
												<li><a href="index-palmistry.html">palmistry</a></li>
												<li><a href="index-vastu.html">vastu shastra</a></li>
												<li><a href="index-gemstone.html">gemstone</a></li>
												<li><a href="index-numerology.html">numerology</a></li>
											</ul>
										</li>
										<li><a href="about.html">about</a></li>
										<li><a href="services.html">services</a></li>
										<li className="as_submenu_li"><a href="#">blog</a>
											<ul className="submenu">
												<li className="as_submenu_li"><a href="#">blog</a>
													<ul className="submenu">
														<li><a href="blog.html">blog default</a></li>
														<li><a href="blog_rs.html">right sidebar</a></li>
														<li><a href="blog_ls.html">left sidebar</a></li>
													</ul>
												</li>
												<li className="as_submenu_li"><a href="#">blog single</a>
													<ul className="submenu">
														<li><a href="blog_single.html">full width</a></li>
														<li><a href="blog_single_rs.html">right sidebar</a></li>
														<li><a href="blog_single_ls.html">left sidebar</a></li>
													</ul>
												</li>
											</ul>
										</li>
										<li><a href="appointment.html">appointment</a></li>
										<li className="as_submenu_li"><a href="#">shop</a>
											<ul className="submenu">
												<li><a href="shop.html">shop</a></li>
												<li><a href="shop_single.html">shop single</a></li>
												<li><a href="cart.html">cart</a></li>
												<li><a href="checkout.html">checkout</a></li>
											</ul>
										</li>								
										<li className="as_submenu_li"><a href="#">pages</a>
											<ul className="submenu">
												<li><a href="team.html">Astrologers</a></li>
												<li><a href="privacy_policy.html">privacy policy</a></li>
												<li><a href="faq.html">FAQ</a></li>
												<li><a href="error.html">404 error</a></li>
											</ul>
										</li>
										<li><a href="contact.html">contact</a></li>
									</ul>
								</div>
							</div>
							<button className="ast_menu_btn"><i className="fa fa-bars" aria-hidden="true"></i></button>
						</div>
					</div>
				</div>
			</div> */}
			{/* <!-- Header End -->    */}
    </>
  )
}